import { useSelector } from '@xstate/react';
import { SearchActor, Selectors } from 'xstate/actors/SearchActor';

/**
 * Read the shared search state (query, scope filters, recent searches) held by
 * `SearchActor`. Mutate it via the actor helpers (`submitSearch`,
 * `setSearchBoxFilter`, …). Both the header search field and the search screen
 * bind to this so they always reflect the same query and scope.
 */
export const useSearchState = () => {
  const query = useSelector(SearchActor, Selectors.query);
  const filterBoxId = useSelector(SearchActor, Selectors.filterBoxId);
  const filterCollectionId = useSelector(
    SearchActor,
    Selectors.filterCollectionId,
  );
  const recentSearches = useSelector(SearchActor, Selectors.recentSearches);

  return { query, filterBoxId, filterCollectionId, recentSearches };
};
